import React from 'react';
import styled from 'styled-components';
import { darkgrey, separatorColor, white } from 'styles/Colors';
import { ReactComponent as CloseIcon } from 'images/close.svg';

export const ConfiguratorWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.14);
  background-color: #fff;
  z-index: 999;
`;

export const Title = styled.div`
  position: relative;
  text-align: center;
  font-family: 'Oswald';
  font-size: 22px;
  color: ${darkgrey};
  padding: 25px 0;
  text-transform: uppercase;
`;

export const ColumnList = styled.div`
  padding: 16px;
  height: calc(100% - 83px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StyledCloseIcon = styled((props) => <CloseIcon {...props} />)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 24px;
  padding: 8px;
  width: 32px;
  height: 32px;

  &:hover {
    cursor: pointer;
  }
`;

export const Badge = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  color: ${white};
  background-color: #007aff;
  border-radius: 32px;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
  width: fit-content;
  padding: 5px 8px;
  cursor: pointer;
`;

export const CurrentFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${separatorColor};
`;

export const PlayerItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
